<template>
    <div>
        <b-container style="margin: 0; padding: 0; max-width: none">
            <b-row style="flex-wrap: nowrap !important;margin: 0;padding: 0;max-width: none;">
                <b-col ref="div_menu" cols="3" style="margin: 0; padding: 0; max-width: 300px">    
                    <div @click="view_message(message.uid)" style="
                        border-width:1px;
                        border-style:solid;
                        border-color:black;
                        padding: 10px;
                        cursor: pointer;
                        " v-for="message in messages" v-bind:key="message.uid">
                            <div :style="'font-size:1em;font-weight:' + ((!message.seen) ? 'bold' : 'normal')">
                                {{ message.title || '(Sans titre)' }}
                            </div>
                            <div style="font-size:0.8em" v-if="mode == 'to'"><i class="fa fa-arrow-left"></i> {{ (message.user_sender.prenom && message.user_sender.nom) ? (message.user_sender.prenom + " " + message.user_sender.nom) : message.user_sender.login }}</div>
                            <div style="font-size:0.8em" v-if="mode == 'from'"><i class="fa fa-arrow-right"></i> {{ (message.user_dest.prenom && message.user_dest.nom) ? (message.user_dest.prenom + " " + message.user_dest.nom) : message.user_dest.login }}</div>
                            <div style="font-size:0.8em"><i class="fa fa-calendar"></i> {{ [message.date] | moment('LLL')}}</div>
                    </div>
                </b-col>                     
                <b-col cols="9" style="margin: 0; padding: 0; max-width: none">
                    <viewmessage  style="
                        padding: 10px;
                        "
                        v-if="message" :mode="mode" :message="message" @delete="deleteMessage"></viewmessage>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
	import store from "../store.js";
    import viewmessage from "./Message.vue";

	export default {
        name: "messages_list",
        components: {
            viewmessage
        },
        props: {
            messages: {
                default: () => []
            },
            mode: {}
        },
		data: function () {
			return {
                message: null
			};
		},
		methods: {
            async view_message(uid)
            {
                for (var i = 0; i < this.messages.length; i++)
                {
                    if (this.messages[i].uid == uid)
                    {
                        if (this.mode == "to" && !this.messages[i].seen)
                            this.$emit("seen", this.messages[i].uid);
                        this.message = this.messages[i];
                    }
                }
            },
            deleteMessage(id)
            {
                this.message = null;
                this.$emit("delete", id, this.mode)
            }
		},
		mounted: async function () {
            
		},
	};
</script>
